import { render } from "./Occupations.vue?vue&type=template&id=c54a17b2"
import script from "./Occupations.vue?vue&type=script&lang=js"
export * from "./Occupations.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__